"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePlangridFeatureFlag = exports.usePlangridAllFeatureFlags = exports.PlangridLaunchDarklyProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");

var _alloyProvider = require("@adsk/alloy-provider");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const LD_API_KEYS = {
  [_acsScWebPlatformApi.ENVS.QA]: "5cfe5a82648b9507525dcb0e",
  [_acsScWebPlatformApi.ENVS.STAGING]: "5d12565bd7bc9707683c5682",
  [_acsScWebPlatformApi.ENVS.PRODUCTION]: "5cfe5a817682e907558f568c"
};
const {
  LaunchDarklyProvider,
  useFeatureFlag: usePlangridFeatureFlag,
  useAllFeatureFlags: usePlangridAllFeatureFlags
} = (0, _alloyProvider.createLaunchDarklyContext)();
exports.usePlangridAllFeatureFlags = usePlangridAllFeatureFlags;
exports.usePlangridFeatureFlag = usePlangridFeatureFlag;

const PlangridLaunchDarklyProvider = props => {
  const env = (0, _acsScWebPlatformApi.getEnv)();
  const apiKey = (0, _react.useMemo)(() => LD_API_KEYS[env], [env]);
  return /*#__PURE__*/_react.default.createElement(LaunchDarklyProvider, _extends({
    apiKey: apiKey
  }, props));
};

exports.PlangridLaunchDarklyProvider = PlangridLaunchDarklyProvider;